module.exports = __webpack_public_path__ + "fonts/yubico_ico@2x.89a03a00a16121182f80e7fec2548f1e.png?";


//////////////////
// WEBPACK FOOTER
// ./~/@okta/okta-signin-widget/dist/img/icons/mfa/yubico_ico@2x.png
// module id = 788
// module chunks = 9